import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
//import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { HashRouter, Switch, Route } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import {SnackbarProvider} from 'notistack';

import AppBar from "@mui/material/AppBar";
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Avatar from '@mui/material/Avatar';
import Button from "@mui/material/Button";
import PersonIcon from '@mui/icons-material/Person';
import LaunchIcon from '@mui/icons-material/Launch';
import {makeStyles} from "@mui/styles";

import {checkCredentials} from "./store/credentialsSlice";
import logo from "./logo.png";
import Preloader from './components/Preloader';
import Home from './pages/Home';
import Form from './pages/Form';
import Themes from './pages/Themes';
import NotFound from './pages/NotFound';
import clsx from "clsx";
import {getUserData} from "./store/userSlice";
import {isMobile} from "is-mobile";

const mdTheme = createTheme();

const useStyles = makeStyles(theme => ({
    root: {},
    appBar: {
        backgroundColor: '#fff !important',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    appBarContainer: {
        paddingLeft: '12px !important',
        paddingRight: '12px !important',
    },
    logo: {
        height: 'auto',
        padding: 0,
        margin: 0
    },
}));

export default function App(props) {

    const classes = useStyles(props);

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);

    const mobile = isMobile();

    useEffect(() => {

        dispatch(checkCredentials())
            .then((response) => {

                // redirect to BaseUrl
                if(!response.payload.data){

                    window.location.replace('https://sendiio.com/');

                } else {

                    dispatch(getUserData()).then((userDataResponse) => {

                        if(userDataResponse.payload){

                            if(userDataResponse.payload.error === 0){

                                setUserData(userDataResponse.payload.user_data);

                                setTimeout(function () {

                                    setLoading(false);

                                }, 1000);

                            } else {

                                alert(response.payload.msg);

                            }

                        } else {

                            window.location.replace('https://sendiio.com/');

                        }

                    });

                }

            });

    }, []);

    if (loading) {
        return <Preloader/>;
    }

    return (
        /*<Router basename={'/form-editor'}>*/
        <HashRouter>
            <ThemeProvider theme={mdTheme}>
                <SnackbarProvider maxSnack={3}>
                    <Box
                        component="main"
                        sx={{
                            backgroundColor: (theme) =>
                                theme.palette.mode === 'light'
                                    ? theme.palette.grey[100]
                                    : theme.palette.grey[900],
                            flexGrow: 1,
                            height: '100vh',
                            overflow: 'auto',
                            paddingTop: '64px'
                        }}
                    >
                        <AppBar id="appBar"
                                className={clsx(classes.appBar)}
                                position="fixed"
                                variant="permanent"
                                style={{top: 0, left: 0, zIndex: 9999}}>
                            <Container className={clsx(classes.appBarContainer)} maxWidth={false}>
                                <Toolbar disableGutters>
                                    <img src={logo} className={classes.logo} style={{maxWidth: mobile ? '120px' : '200px'}} alt="Sendiio" />
                                    <Box sx={{ flexGrow: 1, display: 'flex' }}></Box>
                                    <Box sx={{ flexGrow: 0, display: 'flex', alignItems:'center' }}>
                                        <Button href="https://sendiio.com/dashboard" sx={{boxShadow: 0, color: '#fb5504', marginRight: !mobile && 2, '&:hover': {backgroundColor: 'transparent'}}}>
                                            Dashboard <LaunchIcon sx={{ marginLeft: 1, fontSize: 16 }} />
                                        </Button>
                                        <div style={{flexGrow: 0, display: mobile ? 'none' : 'flex', alignItems:'center'}}>
                                            <span className="pe-12" style={{color: 'rgba(0, 0, 0, 0.7)'}}>{userData.name ? userData.name : 'User'}</span>
                                            <Avatar>
                                                <PersonIcon />
                                            </Avatar>
                                        </div>
                                    </Box>
                                </Toolbar>
                            </Container>
                        </AppBar>

                        <Switch>
                            <Route path="/themes">
                                <Themes />
                            </Route>
                            <Route path="/form/:id">
                                <Form />
                            </Route>
                            <Route path="/form">
                                <Form />
                            </Route>
                            <Route path="/">
                                <Home />
                            </Route>
                            <Route path="*">
                                <NotFound />
                            </Route>
                        </Switch>

                    </Box>
                </SnackbarProvider>
            </ThemeProvider>
        </HashRouter>
        /*</Router>*/
    );

}